document.addEventListener('DOMContentLoaded', () => {
  // Sets the breadcrumb width according to the first content elements width
  const contentWrapper = document.querySelector('.content-wrapper-narrow')

  if (contentWrapper) {
    const breadcrumb = contentWrapper.querySelector('.breadcrumb')

    if (breadcrumb) {
      breadcrumb.classList.toggle('maingrid-item--span-content-small', breadcrumb.nextElementSibling.classList.contains('maingrid-item--span-content-small') || breadcrumb.nextElementSibling.firstElementChild.classList.contains('maingrid-item--span-content-small'))
      breadcrumb.classList.toggle('maingrid-item--span-content-large', !breadcrumb.nextElementSibling.classList.contains('maingrid-item--span-content-small') && !breadcrumb.nextElementSibling.firstElementChild.classList.contains('maingrid-item--span-content-small'))
    }
  }

  // Read solr search param and fire gtm event
  const searchParams = new URLSearchParams(window.location.search)
  if (searchParams.has('tx_solr[q]')) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'pageSearch',
      searchQuery: searchParams.get('tx_solr[q]')
    })
  }
})
